// ====================================================================================
// slider2.module
// ====================================================================================
import $ from "jquery";
import "slick-carousel";

export const init = () => {
  /**
   * Slick dots navigation customization
   *
   * @param {jQueryHTMLElement} elem
   * @param {Number} width - the span width is normally of the same width as other dash-like buttons
   */
  function prepareSliderDotDecor(elem, width) {
    elem.before(`<span style="width:${width}px;"></span>`);
  }

  /**
   * Slick slide change callback
   * (See events table in the docs https://github.com/kenwheeler/slick)
   *
   * @param ev - Slick event
   * @param slick
   * @param {Number} currentSlide - current (activated) slide
   */
  function slideChangeHandler(ev, slick, currentSlide) {
    if (!slick.$dots) return;

    const liElem = slick.$dots.find("li:first button");
    const dotShift = liElem.width() * currentSlide;

    // Dots decorations
    if (!liElem.prev().length && currentSlide > 0) {
      prepareSliderDotDecor(liElem, liElem.width());
    }

    liElem.css("transform", "translateX(" + dotShift + "px)");
  }

  /**
   * Slick slider initialization
   *
   * @param {HTMLElement} container
   * @param {Object} opts - Pass Slick options when needed (optional)
   * with custom options
   */
  function initSlider(container, opts) {
    const arrowsContainer = container.parents(".content-line");
    const arrows = [
      arrowsContainer.find('[data-js="slider-arrows-prev"]').html(),
      arrowsContainer.find('[data-js="slider-arrows-next"]').html(),
    ];
    const fading = typeof opts.fading === "boolean" ? opts.fading : true;

    const slickOpts = {
      rows: 0,
      arrows: true,
      infinite: true,
      autoplaySpeed: 3000,
      fade: fading,
      cssEase: "linear",
    };

    if (arrows[0] && arrows[1]) {
      const htmlArrow = '<a class="arrow arrow--';

      if (opts.arrows) {
        slickOpts.prevArrow = `${htmlArrow}prev" href="#" title="Vorherige">${arrows[0].replace(
          /\s\s+/g,
          ""
        )}</a>`;
        slickOpts.nextArrow = `${htmlArrow}next" href="#" title="Nächste">${arrows[1].replace(
          /\s\s+/g,
          ""
        )}</a>`;
      }
    }

    const optsCustom = opts || {};

    if (container.data("max_slides")) {
      optsCustom.slidesToShow = container.data("max_slides");
    }

    if (container.data("dots")) {
      optsCustom.dots = true;
    }

    if (container.data("autoplay")) {
      optsCustom.autoplay = true;
    }

    if (container.data("arrow_inset")) {
      optsCustom.responsive[0].settings.arrows = true;
    }

    $(container).on("init", function (event, slick) {
      $(event.target).addClass("slider-initialized");
    });
    container.slick(Object.assign(slickOpts, optsCustom));
  }

  if ($('[data-js="slider-2"]').length > 0) {
    $('[data-js="slider-2"]').on("afterChange", slideChangeHandler);

    setTimeout(() => {
      initSlider($('section [data-js="slider-2"]'), {
        rows: 0,
        slidesToShow: 1,
        arrows: true,
        dots: true,
        speed: 500,
        fade: false,
        cssEase: "ease-in-out",
        autoplay: false, // NOTE change to true
        autoplaySpeed: 6000,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              arrows: false,
            },
          },
        ],
      });
    }, 500);
  }
};
